<template>
<v-container>
  <!-- BOC:[breadcrumbs] -->
  <ABreadcrumbV1 :items="breadcrumbs"></ABreadcrumbV1>
  <!-- EOC -->
  <!-- BOC:[form] -->
  <!-- <BreadForm
    :role="role"
    :model="model"
    :url="`${$api.servers.backend}/v1/classroom/${$route.params.parentId}/student/add`"
    action="add"
    :callbackSuccess="callbackSuccess"
  ></BreadForm> -->
  <!-- EOC -->
<PageAdd   :url="`${$api.servers.game}/api/v1/en/moderator/book/${greatGrandParent.id}/chapter/${grandParent.id}/question/${parent.id}/option/add`" :callbackSuccess="callbackSuccess" />
</v-container>
</template>

<script>
  //BOC:[model]
   import modelGreatGrandParent from '@/models/items/book'
  import modelGrandParent from '@/models/items/chapter'
  import modelParent from '@/models/items/chapterQuestion'
  import model from '@/models/items/chapterQuestionOption'
  //EOC
 import PageAdd from "@/components/Moderator/QuestionOption/PageAdd";
  import { mapState } from 'vuex'
  export default {
    components:{
      PageAdd,
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'parent',
      'grandParent',
      'greatGrandParent'
    ],
    data: () => ({
      //BOC:[breadcrumbs]
      breadcrumbs: [],
      //EOC
      //BOC:[model]
      modelGreatGrandParent: modelGreatGrandParent,
      modelGrandParent: modelGrandParent,
      modelParent: modelParent,
      model: model,
      //EOC
      //BOC:[role]
      role:'Moderator',
      //EOC
    }),
    created() {
      //BOC:[breadcrumbs]
      this.breadcrumbs.push({
        text:this.$t("model.name.dashboard"),
        to:{name:'Page'+this.role+'Dashboard'},
        exact:true,
      })
       //
       this.breadcrumbs.push({
        text:this.$t("model.name." + this.modelGreatGrandParent.name.plural.toLowerCase()),
        to:this.$_getRouteBrowse(this.role,this.modelGreatGrandParent.key),
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:(this.greatGrandParent && this.greatGrandParent.name) ? this.greatGrandParent.name : `${this.$t("model.name." + this.modelGreatGrandParent.name.singular.toLowerCase())} ${this.$route.params.greatGrandParentId}`,
        to:this.$_getRouteRead(this.role,this.modelGreatGrandParent.key,this.$route.params.greatGrandParentId,this.greatGrandParent),
        exact:true,
      })
      let greatGrandParentPath = this.$_.cloneDeep(this.breadcrumbs[this.breadcrumbs.length-1].to)
      greatGrandParentPath.query = {tab:'Chapter'}
       //
       this.breadcrumbs.push({
        text:this.$t("model.name." + this.modelGrandParent.name.plural.toLowerCase()),
        to:greatGrandParentPath,
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:(this.grandParent && this.grandParent.name) ? this.grandParent.name : `${this.$t("model.name." + this.modelGrandParent.name.singular.toLowerCase())} ${this.$route.params.grandParentId}`,
        to:this.$_getRouteChildRead(this.role,this.modelGrandParent.key,this.$route.params.grandParentId,this.grandParent,this.modelGreatGrandParent.key,this.$route.params.greatGrandParentId,this.greatGrandParent),
        exact:true,
      })
      let grandParentPath = this.$_.cloneDeep(this.breadcrumbs[this.breadcrumbs.length-1].to)
       grandParentPath.query = {tab:'ChapterQuestion'}
      this.breadcrumbs.push({
        text:this.$t("model.name." + this.modelParent.name.plural.toLowerCase()),
        to:grandParentPath,
        exact:true,
      })
      //
      this.breadcrumbs.push({
        text:(this.myParent && this.myParent.name) ? this.myParent.name : `${this.$t("model.name." + this.modelParent.name.singular.toLowerCase())} ${this.$route.params.parentId}`,
        to:{ name: "PageModeratorBookChapterChapterQuestionRead",params:{grandParentId:this.$route.params.greatGrandParentId, parentId: this.$route.params.grandParentId,id:this.$route.params.parentId} },
        exact:true,
      })
      let path = this.$_.cloneDeep(this.breadcrumbs[this.breadcrumbs.length-1].to)
      path.query = {tab:'ChapterQuestionOption'}
     
      //
      this.breadcrumbs.push({
        text:`${this.$t("string.bread_new")}${this.$t("model.name." + this.model.name.singular.toLowerCase())}`,
        to:{name:'PageModeratorBookChapterChapterQuestionChapterQuestionOptionAdd',params:{parentId:this.$route.params.parentId,parent:this.parent}},
        exact:true,
      })
      //EOC
    },
    mounted() {
      //
    },
    methods: {
      callbackSuccess() {
        let redirect = { name: "PageModeratorBookChapterChapterQuestionRead",params:{grandParentId:this.$route.params.greatGrandParentId, parentId: this.$route.params.grandParentId,id:this.$route.params.parentId} }
        redirect.query = {tab:'QuestionOption'}
        this.$router.push(redirect)
      },
    }
  }
</script>